<template>
  <div class="sw-wrapper">
    <!-- Sidebar -->
    <side-bar class="sw-sidebar" />

    <!-- Contenido principal -->
    <div class="w-100">
      <router-view />
      <!-- Footer global -->
      <AppFooter />
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'Dashboard',
  metaInfo: { title: 'SkillWizard' },
  components: {
    'side-bar': Sidebar,
    AppFooter,
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/variables";

.sw-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PanelControl.vue